import Cookie from 'js-cookie';

const separator = '|';
const allPermissionsCookie = 'all_permissions_pages';
const readOnlyPermissionsCookie = 'read_only_pages';
const readOnlyPermissionsOverridesCookie = 'read_only_pages_override';

const setAllAccess = values => Cookie.set(allPermissionsCookie, values.join(separator));
const setReadOnly = values => Cookie.set(readOnlyPermissionsCookie, values.join(separator));
export const setReadOnlyOverrides = values =>
  Cookie.set(readOnlyPermissionsOverridesCookie, values.join(separator));

export const setPermissionCookies = permissions => {
  const allAccessPermissions = permissions.filter(it => !it.readOnly).map(it => it.pageKey);
  const readOnlyPermissions = permissions.filter(it => it.readOnly).map(it => it.pageKey);

  setAllAccess(allAccessPermissions);
  setReadOnly(readOnlyPermissions);
};

export const getFullPermissions = () => {
  const cookie = Cookie.get(allPermissionsCookie);
  return cookie ? cookie.split(separator) : [];
};

export const getReadOnlyPermissions = () => {
  const cookie = Cookie.get(readOnlyPermissionsCookie);
  const baseReadonlyPermissions = cookie ? cookie.split(separator) : [];
  const readOnlyOverrides = getReadOnlyOverridePermissions();

  return [...baseReadonlyPermissions, ...readOnlyOverrides];
};

export function getReadOnlyOverridePermissions() {
  const cookie = Cookie.get(readOnlyPermissionsOverridesCookie);
  return cookie ? cookie.split(separator) : [];
}

export function hasPermissions() {
  return isArrayWithElements(getFullPermissions()) || isArrayWithElements(getReadOnlyPermissions());
}

export function removeAllPermissionsCookies() {
  Cookie.remove(allPermissionsCookie);
  Cookie.remove(readOnlyPermissionsCookie);
  Cookie.remove(readOnlyPermissionsOverridesCookie);
}

function isArrayWithElements(array) {
  return Array.isArray(array) && !!array.length;
}
